import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-edit-playlist-modal',
  templateUrl: './playlist-modal.component.html',
  styleUrls: ['./playlist-modal.component.css']
})
export class EditPlaylistModalComponent implements OnInit {
  playlistData: any = {};
  playlist: string;
  errorMessage: string = '';

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    const typeMap = {
      1: 'Xstream',
      2: 'M3U',
      4: 'One Stream',
      5: 'Login with Code'
    };

    this.playlist = typeMap[this.playlistData?.type] || 'Unknown';
  }

  isValidUrl(url: string): boolean {
    const pattern = /^(https?|ftp):\/\/(?:[a-zA-Z0-9._%+-]+(?::[a-zA-Z0-9._%+-]+)?@)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/;

    return pattern.test(url);
  }

  save() {
    if (!this.playlistData.name || 
        (this.playlistData.type != 2 && (!this.playlistData.username || !this.playlistData.pwd)) || 
        !this.playlistData.url) {
      this.errorMessage = 'All fields are required.';
      return;
    }

    if (!this.isValidUrl(this.playlistData.url)) {
      this.errorMessage = 'Please enter valid URL i.e start with http:// or https://';
      return;
    }
    console.log(this.playlistData);
    
    this.errorMessage = '';
    this.bsModalRef.content.answer = this.playlistData;
    this.bsModalRef.hide();
  }

  close() {
    this.bsModalRef.hide();
  }
}
